import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "formContainer" }
const _hoisted_5 = {
  key: 0,
  class: "text-center pt-5"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-3" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_11 = { class: "card-body p-4" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "row mb-3" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "col-sm-4" }
const _hoisted_19 = { class: "col-sm-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_multiple_line_chart = _resolveComponent("multiple-line-chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Target Setting",
        text: "Target Setting",
        class: "mb-0"
      }),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newProjectionModal())),
              disabled: _ctx.availableYearsForProjection.length == 0
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "New projection",
                text: "New projection"
              })
            ], 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.targetSettings.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_localized_text, {
              localizedKey: "No data yet",
              text: "No data yet",
              class: "d-block mb-2 pb-1 fw_700"
            }),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newProjectionModal()))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Add new projection",
                    text: "Add new projection"
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Results visualization",
                  text: "Results visualization",
                  class: "d-block mb-2 pb-1 fw_700"
                }),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn w-50 justify-content-center me-2", !_ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tonnesVisualization = false))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Kg",
                      text: "Kg"
                    })
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn w-50 justify-content-center", _ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tonnesVisualization = true))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Tonnes",
                      text: "Tonnes"
                    })
                  ], 2)
                ])
              ])
            ]),
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetSettings, (target, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card mb-4",
                key: index
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Created on",
                        text: "Created on",
                        class: "fw_700 d-block mb-1"
                      }),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$filters.date(target.createdOn)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Base year",
                        text: "Base year",
                        class: "fw_700 d-block mb-1"
                      }),
                      _createElementVNode("p", null, _toDisplayString(target.baseYear), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Target year",
                        text: "Target year",
                        class: "fw_700 d-block mb-1"
                      }),
                      _createElementVNode("p", null, _toDisplayString(target.targetYear), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scope-01 Reduction",
                        text: "Scope-01 Reduction",
                        class: "fw_700 d-block mb-1"
                      }),
                      _createElementVNode("p", null, _toDisplayString(target.scope1ReductionPercentage) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scope-02 Reduction",
                        text: "Scope-02 Reduction",
                        class: "fw_700 d-block mb-1"
                      }),
                      _createElementVNode("p", null, _toDisplayString(target.scope2ReductionPercentage) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scope-03 Reduction",
                        text: "Scope-03 Reduction",
                        class: "fw_700 d-block mb-1"
                      }),
                      _createElementVNode("p", null, _toDisplayString(target.scope3ReductionPercentage) + "%", 1)
                    ])
                  ]),
                  (!_ctx.tonnesVisualization)
                    ? (_openBlock(), _createBlock(_component_multiple_line_chart, {
                        dataSets: [
                            { label: 'Scope-01', data: target.scope1EmissionsByYear, color: 'red' },
                            { label: 'Scope-01 Target', data: target.scope1TargetByYear, color: 'orange' },
                            { label: 'Scope-02', data: target.scope2EmissionsByYear, color: 'blue' },
                            { label: 'Scope-02 Target', data: target.scope2TargetByYear, color: 'lightblue' },
                            { label: 'Scope-03', data: target.scope3EmissionsByYear, color: 'green' },
                            { label: 'Scope-03 Target', data: target.scope3TargetByYear, color: 'lightgreen' }
                        ],
                        weightLabel: "kg CO2e",
                        key: _ctx.multilineChartKgId + '_' + target.createdOn
                      }, null, 8, ["dataSets"]))
                    : (_openBlock(), _createBlock(_component_multiple_line_chart, {
                        dataSets: [
                            { label: 'Scope-01', data: _ctx.getConvertedEmissionsByYear(target.scope1EmissionsByYear), color: 'red' },
                            { label: 'Scope-01 Target', data: _ctx.getConvertedEmissionsByYear(target.scope1TargetByYear), color: 'orange' },
                            { label: 'Scope-02', data: _ctx.getConvertedEmissionsByYear(target.scope2EmissionsByYear), color: 'blue' },
                            { label: 'Scope-02 Target', data: _ctx.getConvertedEmissionsByYear(target.scope2TargetByYear), color: 'lightblue' },
                            { label: 'Scope-03', data: _ctx.getConvertedEmissionsByYear(target.scope3EmissionsByYear), color: 'green' },
                            { label: 'Scope-03 Target', data: _ctx.getConvertedEmissionsByYear(target.scope3TargetByYear), color: 'lightgreen' }
                        ],
                        weightLabel: "Tonnes",
                        key: _ctx.multilineChartTonnesId + '_' + target.createdOn
                      }, null, 8, ["dataSets"]))
                ])
              ]))
            }), 128))
          ]))
    ])
  ], 64))
}